export default __webpack_public_path__ + "static/media/pexels-pixabay-40739.dbd72128.jpg";